// Calls `fn` every `intervalMs` while `active`, one call at a time (the next
// waits for the previous to finish), paused while the browser tab is hidden,
// and stopped after `maxMs` so a job stuck in the queue doesn't poll forever.
import { useEffect, useRef } from 'react';

export const POLL_MAX_MS = 30 * 60 * 1000;

export default function usePolling(fn, active, intervalMs, maxMs = POLL_MAX_MS) {
    const latest = useRef(fn);
    latest.current = fn;

    useEffect(() => {
        if (!active) return undefined;
        const started = Date.now();
        let timer = null;
        let stopped = false;
        const tick = async () => {
            if (stopped || Date.now() - started > maxMs) return;
            if (typeof document === 'undefined' || !document.hidden) await latest.current();
            if (!stopped) timer = setTimeout(tick, intervalMs);
        };
        timer = setTimeout(tick, intervalMs);
        return () => {
            stopped = true;
            clearTimeout(timer);
        };
    }, [active, intervalMs, maxMs]);
}
